import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import Delo from "../../img/organizers/dilo_1200.webp";
import Mmr from "../../img/organizers/mmr.svg";
import Top from "../../img/organizers/top100.svg";
import Womo from "../../img/organizers/womo-new.webp";
import Ekonomika from "../../img/organizers/Logo_Ekonomika.svg";

import Get from "../../img/organizers/get.svg";
import Hrws from "../../img/organizers/hrws.svg";
import Prmrfn from "../../img/organizers/prmrfn.svg";
import She from "../../img/organizers/she.svg";
import Bws from "../../img/organizers/bws.svg";
import Mrktng from "../../img/organizers/mrktng.svg";


import ArrowDecor from "../../img/decor/arrow-decor.webp";
import CenterDecor from "../../img/organizers/center_decor.webp";


const EventOrganizers = () => {
    return (
        <section className="relative mb-[60] lg:mb-[120px]">
            <div className="bg-[#00007c] py-[60px] lg:py-[120px]">

                <div className="container max-w-screen-xl mx-auto px-5">

                    <div className="relative mb-8 lg:mb-20">
                        <h2 className="mb-[50px] text-center text-[32px] font-bold uppercase leading-none text-white md:text-[40px] lg:mb-[65px] lg:text-[52px]">Організатори</h2>

                        <div className="relative z-10 flex justify-center gap-4 md:justify-between">
                            {/* DELO */}
                            <a href="https://delo.ua" target="_blank" rel="noopener noreferrer"
                                className="relative flex flex-1 items-center justify-center text-right bg-[#babafe] 
                                    max-md:rounded-tr-[30px] lg:rounded-tr-[50px]
                                     lg:px-[25px] px-[15px] w-full  xl:pr-[40px]
                                    max-w-[127px] lg:max-w-[246px] lg:min-h-[106px] lg:justify-end">
                                <p className="text-[9px] leading-[130%] z-10 max-w-full md:text-[11px] lg:text-[16px] lg:max-w-[150px]">
                                    лідер ділового контенту Dilo.ua
                                </p>
                                <span className="absolute z-10 w-[73px] h-[73px] bg-white rounded-full flex items-center justify-center 
                                    top-[30px] -left-[40px] md:-top-[10px] md:left-auto md:-right-[55px] xl:-right-[125px] lg:w-[120px] lg:h-[120px]">
                                    <img src={Delo} alt="dilo" className="w-[60%] relative z-10" />
                                </span>

                                <span className="absolute w-[60px] h-[18px] -bottom-[63px] left-0 md:w-[110px] md:h-[23px] md:left-[125%] md:bottom-[15px] 
                                                    lg:w-[175px] lg:h-[53px] lg:left-[120%]">
                                    <svg viewBox="0 0 155 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M153 34.5L120 1.5H0" stroke="#babafe" stroke-width="3" stroke-dasharray="10 10" />
                                    </svg>
                                </span>

                            </a>

                            {/* MMR */}
                            <a href="https://mmr.ua" target="_blank" rel="noopener noreferrer"
                                className="relative flex flex-1 items-center justify-center text-left bg-[#babafe]  
                                    max-md:rounded-tl-[30px] lg:rounded-tl-[50px] lg:px-[25px] xl:pl-[40px]
                                 px-[15px] w-full max-w-[127px] min-h-[58px] lg:max-w-[246px] lg:min-h-[106px] lg:justify-start">
                                <p className="text-[9px] leading-[130%] z-10 max-w-full md:text-[11px] lg:text-[16px]">
                                    онлайн-медіа про PR та маркетинг MMR.ua
                                </p>
                                <span
                                    className="absolute z-10 w-[73px] h-[73px] bg-white rounded-full flex items-center justify-center top-[34px] 
                                    -right-[40px] md:-top-[10px] md:right-auto md:-left-[55px] xl:-left-[125px] lg:w-[120px] lg:h-[120px]">
                                    <img src={Mmr} alt="mmr" className="w-[60%] relative z-10" />
                                </span>
                                <span
                                    className="absolute w-[60px] h-[18px] -bottom-[64px] right-0 md:w-[110px] md:h-[23px] md:right-[125%] md:bottom-[15px] 
                                                        lg:w-[175px] lg:h-[53px] lg:right-[110%]">
                                    <svg viewBox="0 0 154 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 34L34 1H154" stroke="#babafe" strokeWidth="2" strokeDasharray="10 10" />
                                    </svg>
                                </span>
                            </a>
                        </div>
                        {/* CENTER BLOCK */}
                        <div className="relative flex justify-center py-[25px] md:py-0 md:my-[-50px] ">
                            <a href="https://ekonomika.ua/" target="_blank" rel="noopener noreferrer"
                                className="relative flex shrink-0 flex-col items-center justify-center gap-[10px] md:gap-[20px] w-[162px] h-[162px] 
                                    md:w-[210px] md:h-[210px] lg:w-[335px] lg:h-[335px] rounded-full  text-center">
                                <img src={Ekonomika} alt="Ekonomika+" className="w-[120px] md:w-auto z-10 relative" />
                                <p className="text-[10px] md:text-[20px] leading-[130%] text-balance z-10 relative">бізнес/медіа бюро, до
                                    якого входять:</p>
                                {[['top-[25px]', '-left-[3px]', 'left-0'], ['top-[25px]', '-right-[3px]', 'right-0'], ['bottom-[25px]', '-left-[3px]', 'left-0'], ['bottom-[25px]', '-right-[3px]', 'right-0']].map(([pos, shift, reset], i) => (
                                    <span key={i}
                                        className={`absolute z-10 w-[18px] h-[18px] lg:w-[40px] lg:h-[40px] bg-[radial-gradient(circle_at_35%_30%,#fff_0%,#E7DCFF_40%,#7770FF_100%)] border-[2.5px] md:border-[5px] border-white rounded-full ${pos} ${shift} md:${reset}`} />
                                ))}
                                <span
                                    className="absolute  w-[180px] h-[180px] md:w-[255px] md:h-[255px] lg:w-[385px] lg:h-[385px] rounded-full border-[6px] border-[#babafe]" />
                                <img src={CenterDecor} className="absolute w-full h-full object-cover " />
                            </a>
                        </div>

                        {/* BOTTOM */}
                        <div className="relative z-10 flex justify-center gap-4 md:justify-between">
                            {/* TOP 100 */}
                            <a href="https://delo.ua/top100" target="_blank" rel="noopener noreferrer"
                                className="relative flex flex-1 items-center justify-center bg-[#babafe] 
                                max-md:rounded-tr-[30px] lg:rounded-tr-[50px] lg:px-[25px] xl:pr-[40px]
                                 px-[15px] w-full max-w-[127px] min-h-[58px] lg:justify-end lg:max-w-[246px] lg:min-h-[106px]">
                                <p className="text-[9px] leading-[130%] z-10 max-w-full md:text-[11px] md:text-right lg:text-[16px] ">
                                    журнал «ТОП-100. Рейтинги найбільших»
                                </p>
                                <span
                                    className="absolute z-10 w-[73px] h-[73px] bg-white rounded-full flex items-center justify-center bottom-[35px]
                                     -left-[40px] md:-bottom-[7px] md:left-auto md:-right-[55px] xl:-right-[125px] lg:w-[120px] lg:h-[120px]">
                                    <img src={Top} alt="top100" className="w-[60%] relative z-10" />
                                </span>
                                <span
                                    className="absolute w-[60px] h-[18px] -top-[60px] left-0 md:w-[110px] md:h-[23px] md:left-[125%] md:top-[15px] 
                                                        lg:w-[175px] lg:h-[53px] lg:left-[110%] lg:top-[25px]">
                                    <svg viewBox="0 0 154 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M153 1L120 34H0" stroke="#babafe" strokeWidth="2" strokeDasharray="10 10" />
                                    </svg>
                                </span>
                            </a>

                            {/* WOMO */}
                            <a href="https://womo.ua" target="_blank" rel="noopener noreferrer"
                                className="relative flex z-10 flex-1 items-center justify-center bg-[#babafe] 
                                max-md:rounded-tl-[30px] lg:rounded-tl-[50px] lg:px-[25px] px-[15px] xl:pl-[40px]
                                w-full max-w-[127px] min-h-[58px]  lg:justify-start lg:max-w-[246px] lg:min-h-[106px]">
                                <p className="text-[9px] leading-[130%] z-10 max-w-full md:text-[11px] md:text-left lg:text-[16px] lg:max-w-[150px]">
                                    дайджест ділової жінки Womo.ua
                                </p>
                                <span
                                    className="absolute z-10 w-[73px] h-[73px] bg-white rounded-full flex items-center justify-center bottom-[35px] 
                                    -right-[40px] md:-bottom-[7px] md:right-auto md:-left-[55px] xl:-left-[125px] lg:w-[120px] lg:h-[120px]">
                                    <img src={Womo} alt="womo" className="w-[60%] relative z-10" />
                                </span>
                                <span
                                    className="absolute w-[60px] h-[18px] -top-[60px] right-0 md:w-[110px] md:h-[23px] md:right-[125%] md:top-[15px] 
                                                        lg:w-[175px] lg:h-[53px] lg:right-[110%] lg:top-[25px]">
                                    <svg viewBox="0 0 154 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L34 34H154" stroke="#babafe" strokeWidth="2" strokeDasharray="10 10" />
                                    </svg>
                                </span>
                            </a>
                        </div>

                    </div>

                </div>

            </div>




            <div className="pt-[40px] pb-[60px] xl:pt-[60px] xl:pb-[120px] bg-[#faf9ff]">
                <div className="container max-w-full mx-auto px-[clamp(20px,calc(20px+130*((100vw-390px)/1530)),150px)]">

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-[clamp(20px,calc(20px+34*((100vw-768px)/1152)),60px)]
                        mb-[40px] pb-10  xl:mb-[80px] xl:pb-16 border-b border-black/50">
                        <div className="flex items-center gap-[clamp(12px,calc(12px+34*((100vw-768px)/1152)),46px)]">
                            <img src={ArrowDecor} alt="About" className="block h-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] w-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] flex-shrink-0
                                " />
                            <div className="flex flex-col">
                                <h3 className="font-bold text-[clamp(22px,calc(22px+38*((100vw-768px)/1152)),59px)] leading-tight uppercase">10000+</h3>
                                <p className="font-semibold text-[7px] uppercase lg:text-base leading-none">відвідувачів </p>
                            </div>
                        </div>
                        <div className="flex items-center gap-[clamp(12px,calc(12px+34*((100vw-768px)/1152)),46px)]">
                            <img src={ArrowDecor} alt="About" className="block h-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] w-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] flex-shrink-0
                                " />
                            <div className="flex flex-col">
                                <h3 className="font-bold text-[clamp(22px,calc(22px+38*((100vw-768px)/1152)),59px)] leading-tight uppercase">500+</h3>
                                <p className="font-semibold text-[7px] uppercase lg:text-base leading-none">спікерів</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-[clamp(12px,calc(12px+34*((100vw-768px)/1152)),46px)]">
                            <img src={ArrowDecor} alt="About" className="block h-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] w-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] flex-shrink-0
                                " />
                            <div className="flex flex-col">
                                <h3 className="font-bold text-[clamp(22px,calc(22px+38*((100vw-768px)/1152)),59px)] leading-tight uppercase">60+</h3>
                                <p className="font-semibold text-[7px] uppercase lg:text-base leading-none">проведених заходів</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-[clamp(12px,calc(12px+34*((100vw-768px)/1152)),46px)]">
                            <img src={ArrowDecor} alt="About" className="block h-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] w-[clamp(29px,calc(29px+45*((100vw-768px)/1152)),74px)] flex-shrink-0
                                " />
                            <div className="flex flex-col">
                                <h3 className="font-bold text-[clamp(22px,calc(22px+38*((100vw-768px)/1152)),59px)] leading-tight uppercase">20+</h3>
                                <p className="font-semibold text-[7px] uppercase lg:text-base leading-none text-balance">церемоній нагородження лідерів</p>
                            </div>
                        </div>
                    </div>

                    <h2 className="relative text-xl text-center font-bold uppercase mb-6 z-10 lg:text-3xl lg:mb-16">Компанія щороку проводить:</h2>

                    <div className="relative flex flex-col gap-3 pb-3 md:flex-row md:justify-center md:flex-wrap md:gap-y-4 md:gap-x-6 z-10">
                        <a href="https://prmarathon.mmr.ua/" target="_blank" className="relative  flex items-center gap-4 pr-2  md:basis-[calc(50%-12px)] xl:basis-[calc(33.333%-16px)]">
                            <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                            border-[2px] border-[#babafe]">
                                <img src={Prmrfn} alt="Delo.ua" className="w-2/3" />
                            </div>
                            <p className="text-base uppercase font-semibold text-black">Тотальний PR MRTHN</p>

                            <div className="absolute rounded-lg right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                            bg-[#babafe] rounded-tr-[50px]"></div>
                        </a>
                        <a href="https://mrktng.mmr.ua/" target="_blank" className="relative flex items-center gap-4 pr-2  md:basis-[calc(50%-12px)] xl:basis-[calc(33.333%-16px)]">
                            <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                            border-[2px] border-[#babafe]">
                                <img src={Mrktng} alt="Delo.ua" className="w-2/3" />
                            </div>
                            <p className="text-base uppercase font-semibold text-black">MRKTNG-марафон: Підкреслити головне</p>

                            <div className="absolute rounded-lg right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                            bg-[#babafe] rounded-tr-[50px]"></div>
                        </a>
                        <a href="https://hrws.delo.ua/" target="_blank" className="relative flex items-center gap-4 pr-2 md:basis-[calc(50%-12px)] xl:basis-[calc(33.333%-16px)]">
                            <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                            border-[2px] border-[#babafe]">
                                <img src={Hrws} alt="Delo.ua" className="w-2/3" />
                            </div>
                            <p className="text-base uppercase font-semibold text-black">Люди. Сенси. Форми</p>

                            <div className="absolute right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                            bg-[#babafe] rounded-tr-[50px] "></div>
                        </a>
                        <a href="https://bws.delo.ua/" target="_blank" className="relative flex items-center gap-4 pr-2 md:basis-[calc(50%-12px)] xl:basis-[calc(33.333%-16px)]">
                            <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                            border-[2px] border-[#babafe]">
                                <img src={Bws} alt="Delo.ua" className="w-2/3" />
                            </div>
                            <p className="text-base uppercase font-semibold text-black">БІЗНЕСИ СМІЛИВИХ</p>

                            <div className="absolute rounded-lg right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                            bg-[#babafe] rounded-tr-[50px]"></div>
                        </a>
                        <a href="https://she.womo.ua/" target="_blank" className="relative flex items-center gap-4 pr-2 md:basis-[calc(50%-12px)] xl:basis-[calc(33.333%-16px)]">
                            <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                            border-[2px] border-[#babafe]">
                                <img src={She} alt="Delo.ua" className="w-2/3" />
                            </div>
                            <p className="text-base uppercase font-semibold text-black">SHE CONGRESS: Рішуча. Справжня. Небайдужа</p>

                            <div className="absolute rounded-lg right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                            bg-[#babafe] rounded-tr-[50px]"></div>
                        </a>
                    </div>
                </div>
            </div>

        </section>
    );
};

export default EventOrganizers;